import {Network, NetworkContract} from 'app/components/entities/network/model';

function mapInterface(c: NetworkContract.Interface): Network.Interface {
  const {id, name, primary, status, active, mac_address, address} = c;
  return {id, name, primary, status, active, mac: mac_address, ip: address};
}

export const NetworkMapper = {mapInterface};
